import { useDictionary } from "@adamlip/okeoke.client"
import { Button, Tab, Tabs } from "@nextui-org/react"
import CouponModalV2 from "components/Modals/CouponModalV2"
import VipCardModalV2 from "components/Modals/VipCardModalV2"
import { UserContext } from "contexts/UserContext"
import { useContext, useEffect, useState } from "react"
import AddCouponModal from "components/AddCouponModal"
import toast from "react-hot-toast"
import { AppParamsContext } from "contexts/AppParamsContext"
import CouponCard from "views/Coupons/CouponCard"
import Login from "views/Login"

function Coupons() {
  const { getValue } = useDictionary()
  const {
    coupons,
    activateCoupon,
    claimCoupon,
    refreshCoupons,
    isVipBrand,
    userLoggedIn,
  } = useContext(UserContext)

  const { appParams } = useContext(AppParamsContext)

  const [isOpen, setIsOpen] = useState(false)
  const [selectedCoupon, setSelectedCoupon] = useState(null)
  const [couponList, setCouponList] = useState(null)
  const [vipCardOpen, setVipCardOpen] = useState(false)
  const [addCouponModalOpen, setAddCouponModalOpen] = useState(false)
  const [activateInProgress, setActivateInProgress] = useState(false)
  const [currentCoupon, setCurrentCoupon] = useState(null)
  const [containerClass, setContainerClass] = useState("")
  const [loginModal, setLoginModal] = useState(false)

  const handleActivateCoupon = (coupon) => {
    if (coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, false).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_activated"))
        refreshCoupons()
        setCurrentCoupon(response.data)
      }
      setActivateInProgress(false)
    })
  }

  const handleDeActivateCoupon = (coupon) => {
    if (!coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, true).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_deactivated"))
        refreshCoupons()
        setCurrentCoupon(response.data)
      }
      setActivateInProgress(false)
    })
  }

  const handleClaimCoupon = (coupon) => {
    if (coupon.isClaimed) return null
    setActivateInProgress(coupon?.code)
    claimCoupon(coupon?.code).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_claimed"))
        refreshCoupons()
        setCurrentCoupon(response.data)
      }
      setActivateInProgress(false)
    })
  }

  const openCouponModal = (coupon) => {
    if (coupon != null) {
      setIsOpen(true)
      setSelectedCoupon(coupon)
    }
  }

  const openVipCardModal = () => {
    setVipCardOpen(true)
  }

  useEffect(() => {
    setCouponList(coupons)
  }, [coupons])

  useEffect(() => {
    let containerBottom = ""
    if (appParams?.navigation?.bottomBarSettings?.layout === "floating") {
      containerBottom = "!bottom-[90px]"
      if (appParams?.navigation?.bottomBarSettings?.size === "70") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[118px]"
        } else {
          containerBottom = "!bottom-[142px]"
        }
      }
      if (appParams?.navigation?.bottomBarSettings?.size === "55") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[102px]"
        } else {
          containerBottom = "!bottom-[124px]"
        }
      }
      if (appParams?.navigation?.bottomBarSettings?.size === "40") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[86px]"
        } else {
          containerBottom = "!bottom-[110px]"
        }
      }
    } else {
      containerBottom = "!bottom-[60px]"
      if (appParams?.navigation?.bottomBarSettings?.size === "70") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[88px]"
        } else {
          containerBottom = "!bottom-[112px]"
        }
      }
      if (appParams?.navigation?.bottomBarSettings?.size === "55") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[72px]"
        } else {
          containerBottom = "!bottom-[94px]"
        }
      }
      if (appParams?.navigation?.bottomBarSettings?.size === "40") {
        if (appParams?.navigation?.bottomBarSettings?.text === "hidden") {
          containerBottom = "!bottom-[56px]"
        } else {
          containerBottom = "!bottom-[80px]"
        }
      }
    }
    setContainerClass(containerBottom)
  }, [appParams])

  if (!userLoggedIn) {
    return (
      <div className="flex flex-col gap-2 items-center justify-center h-full w-full max-w-[95%] mx-auto  relative overflow-y-scroll pb-[50%]">
        <div className="w-full text-center text-xl font-bold">
          {getValue("app_v2_youAreNotLoggedIn")}
        </div>
        <div className="w-full text-center mb-4">
          {getValue("app_v2_youAreNotLoggedIn_desc")}
        </div>
        <Button color="primary" onPress={() => setLoginModal(true)}>
          {getValue("app_v2_login")}
        </Button>
        {loginModal && <Login isOpen={loginModal} setIsOpen={setLoginModal} />}
      </div>
    )
  }
  if (!isVipBrand)
    return (
      <div className="relative px-2 h-full w-full  flex flex-col items-center justify-center gap-4 overflow-y-hidden pt-4 ">
        <div className="">{getValue("vip.not.available")}</div>
        <Button color="primary" onPress={() => window.location.reload()}>
          {getValue("vip.reload")}
        </Button>
      </div>
    )

  return (
    <>
      <div className="relative px-2 h-full w-full  flex flex-col gap-4 overflow-y-hidden pt-4 ">
        <Tabs
          fullWidth
          color="secondary"
          classNames={{
            panel: "h-full w-full overflow-y-auto overflow-x-visible",
            tab: appParams?.styles?.fonts?.capitalize
              ? "font-bold uppercase"
              : "",
          }}
        >
          <Tab key={"all"} title={getValue("app_v2_coupons_title")}>
            {(couponList || []).length < 1 && (
              <div className="message">
                {getValue("app_v2_coupons_noCoupons")}
              </div>
            )}
            <div className="flex flex-col gap-2 pb-[50%] md:flex-row md:flex-wrap overflow-x-visible">
              {(couponList || []).sort((a, b) => ((a?.attributes?.idx || 0) > (b?.attributes?.idx || 0)) ? 1 : -1).map((coupon) => (
                <CouponCard
                  key={coupon.id}
                  coupon={coupon}
                  activateInProgress={activateInProgress}
                  appParams={appParams}
                  handleClaimCoupon={handleClaimCoupon}
                  handleActivateCoupon={handleActivateCoupon}
                  mode="all"
                  openCouponModal={openCouponModal}
                  handleDeActivateCoupon={handleDeActivateCoupon}
                />
              ))}
            </div>
          </Tab>
          <Tab key={"claimed"} title={getValue("app_v2_coupons_myCoupons")}>
            <div className="flex flex-col gap-2 pb-[50%] md:flex-row md:flex-wrap">
              {(couponList || [])
                ?.filter((coupon) => coupon.isClaimed === true)
                .map((coupon) => (
                  <CouponCard
                    key={coupon.id}
                    coupon={coupon}
                    activateInProgress={activateInProgress}
                    appParams={appParams}
                    handleClaimCoupon={handleClaimCoupon}
                    handleActivateCoupon={handleActivateCoupon}
                    mode="claimed"
                    openCouponModal={openCouponModal}
                    handleDeActivateCoupon={handleDeActivateCoupon}
                  />
                ))}
            </div>
          </Tab>
          <Tab
            key={"active"}
            title={getValue("app_v2_coupons_myActiveCoupons")}
          >
            {(couponList || [])?.filter((coupon) => coupon.active === true)
              .length === 0 && (
                <div className="">
                  {getValue("app_v2_coupons_myActiveCoupons_no_coupons")}
                </div>
              )}
            <div className="flex flex-col gap-2 pb-[50%] md:flex-row md:flex-wrap">
              {(couponList || [])
                ?.filter((coupon) => coupon.active === true)
                .map((coupon) => (
                  <CouponCard
                    key={coupon.id}
                    coupon={coupon}
                    activateInProgress={activateInProgress}
                    appParams={appParams}
                    handleClaimCoupon={handleClaimCoupon}
                    handleActivateCoupon={handleActivateCoupon}
                    mode="active"
                    openCouponModal={openCouponModal}
                    handleDeActivateCoupon={handleDeActivateCoupon}
                  />
                ))}
            </div>
          </Tab>
        </Tabs>
      </div>
      <div
        className={`vip-card-button md:bg-black md:bg-opacity-70 md:p-6 md:rounded-lg md:!bottom-0 ${(appParams?.navigation?.bottomBarSettings?.enabled == null ||
          (appParams?.navigation?.bottomBarSettings?.enabled === false &&
            appParams?.styles?.topBottomBar?.layout)) === "floating"
          ? "!bottom-[calc(var(--bottomBar-height)+35px)]"
          : `my-2 ${containerClass}`
          } `}
      >
        <Button
          color="primary"
          radius="full"
          className="font-semibold"
          onClick={() => openVipCardModal()}
        >
          {getValue("app_v2_coupons_vipCard")}
        </Button>
        <Button
          color="secondary"
          radius="full"
          className="font-semibold ml-1"
          onClick={() => setAddCouponModalOpen(true)}
        >
          {getValue("app_v2_coupons_addCoupon")}
        </Button>
      </div>
      <CouponModalV2
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        coupon={selectedCoupon}
        setCurrentCoupon={setCurrentCoupon}
        currentCoupon={currentCoupon}
        handleActivateCoupon={handleActivateCoupon}
        handleDeActivateCoupon={handleDeActivateCoupon}
        activateInProgress={activateInProgress}
      />
      <VipCardModalV2 isOpen={vipCardOpen} setIsOpen={setVipCardOpen} />
      <AddCouponModal
        isOpen={addCouponModalOpen}
        setIsOpen={setAddCouponModalOpen}
      />
    </>
  )
}

export default Coupons
